import { Injectable } from '@angular/core';
import {Observable, throwError, of} from 'rxjs';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { baseUrls } from './appConstant';
import { catchError, retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private httpClient: HttpClient) {}

  getData(staticUrl: string){
    let url = baseUrls['base'] + staticUrl;
    return this.httpClient.get(url);
  }

  getDatabill(staticUrl: string){
    let url = baseUrls['bill'] + staticUrl;
    return this.httpClient.get(url);
  }
  
  postFormDataBase(staticUrl: string, data: any): Observable<any> {
    let url= baseUrls['base']+staticUrl;
    return this.httpClient.post (url,data).pipe(
      catchError(this.handleError));
  }
  postFormDataBilling(staticUrl:string,data:any, header: any = ''):Observable<any> {
    const requestOptions = {
      headers: new HttpHeaders(header),
    };
    let url=baseUrls['bill']+staticUrl;
    return this.httpClient.post (url, data, requestOptions).pipe(
      catchError(this.handleError));
  }

  postFormData(staticUrl: string, data: any): Observable<any> {
    let url= baseUrls['bill']+staticUrl;
    return this.httpClient.post (url,data, { headers :{token: localStorage.getItem('userToken')}}).pipe(
      catchError(this.handleError));
  }

  postFormDatabill(staticUrl: string, data: any, header: any = ''): Observable<any> {
    const requestOptions = {
      headers: new HttpHeaders(header),
    };
    let url= baseUrls['bill']+staticUrl;
    return this.httpClient.post (url, data, requestOptions).pipe(
      catchError(this.handleError));
  }

  postDeletebill(staticUrl: string): Observable<any> {
    let url= baseUrls['bill']+staticUrl;
    return this.httpClient.delete(url).pipe(
      catchError(this.handleError));
  }

  postDatauser(staticUrl: string, data){
    let url = baseUrls['global'] + staticUrl;
    let headers: HttpHeaders = new HttpHeaders();
    let tokens=localStorage.getItem('userToken')?localStorage.getItem('userToken'):'';
    headers = headers.append('Token', tokens);
    return this.httpClient.post(url,data,{headers});
  }

  handleError(error: HttpErrorResponse): Observable<any> {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.log('Backend response', error);
      return of({ success:false, message: 'Something bad happened; please try again later.', error: error.error });
    }
    // return an observable with a user-facing error message
    return of({ success:false, message: 'Something bad happened; please try again later.' });
  }
}
